import React, { useState } from 'react';
import axios from '../config/api';
import { API_URL } from '../config/api';

function PollModal({ poll, tags, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    question: poll?.question || '',
    tags: poll?.tags || []
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (poll) {
        await axios.put(`${API_URL}/api/admin/polls/${poll.pollId}`, formData);
      } else {
        await axios.post(`${API_URL}/api/admin/polls`, formData);
      }
      onSuccess();
    } catch (error) {
      alert(error.response?.data?.detail || 'Failed to save poll');
    }
  };

  const toggleTag = (tagId) => {
    if (formData.tags.includes(tagId)) {
      setFormData({ ...formData, tags: formData.tags.filter(id => id !== tagId) });
    } else if (formData.tags.length < 5) {
      setFormData({ ...formData, tags: [...formData.tags, tagId] });
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full p-6 max-h-[90vh] flex flex-col" data-testid="poll-modal">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          {poll ? 'Edit Poll' : 'Create New Poll'}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4 flex-1 overflow-hidden flex flex-col">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Question</label>
            <textarea
              value={formData.question}
              onChange={(e) => setFormData({ ...formData, question: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
              rows="3"
              required
              data-testid="poll-question-input"
            />
          </div>

          <div className="flex-1 overflow-hidden flex flex-col min-h-0">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Tags (Max 5 - {formData.tags.length}/5 selected)
            </label>
            <div className="flex-1 overflow-y-auto border border-gray-200 rounded-lg p-3">
              <div className="flex flex-wrap gap-2">
                {tags.map(tag => (
                  <button
                    key={tag.tagId}
                    type="button"
                    onClick={() => toggleTag(tag.tagId)}
                    className={`px-4 py-2 rounded-full font-medium transition-all ${
                      formData.tags.includes(tag.tagId)
                        ? 'text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                    style={{
                      backgroundColor: formData.tags.includes(tag.tagId) ? tag.color : undefined
                    }}
                    disabled={!formData.tags.includes(tag.tagId) && formData.tags.length >= 5}
                    data-testid={`modal-tag-${tag.name}`}
                  >
                    {tag.name}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="submit"
              className="flex-1 bg-green-500 text-white py-3 rounded-lg font-semibold hover:bg-green-600"
              data-testid="save-poll-button"
            >
              {poll ? 'Update Poll' : 'Create Poll'}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-gray-300 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-400"
              data-testid="cancel-poll-button"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PollModal;
